import { render, staticRenderFns } from "./PageBaseComponent.vue?vue&type=template&id=7badd642&"
import script from "./PageBaseComponent.vue?vue&type=script&lang=js&"
export * from "./PageBaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports